import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa6';
import type { IconType } from 'react-icons';
const LINKS = [{
  label: 'Nosotros',
  href: '#quienes-somos'
}, {
  label: 'Sectores',
  href: '#sectores'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
interface SocialLink {
  label: string;
  href: string;
  icon: IconType;
}
const SOCIALS: SocialLink[] = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/vivomedia.uy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
  icon: FaInstagram
}, {
  label: 'YouTube',
  href: '#',
  icon: FaYoutube
}, {
  label: 'Facebook',
  href: '#',
  icon: FaFacebookF
}, {
  label: 'TikTok',
  href: '#',
  icon: FaTiktok
}];
export function Footer() {
  return <footer className="w-full border-t-2 border-vm-electric bg-black" data-id="element-82" data-mp="29xlzel58oyhi">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10" data-id="element-83" data-mp="2eyjqjn8892v5">
        <div className="flex flex-col justify-between gap-10 lg:flex-row lg:items-center" data-id="element-84" data-mp="2evxbz3mx5n3f">
          <a href="#top" aria-label="Vivo Media — Inicio" className="flex h-32 w-full max-w-[560px] shrink-0 items-center sm:h-40 lg:h-48 lg:w-[560px]" data-id="element-85" data-mp="3lbdd6ucasbmc">
            <img src="https://cdn.magicpatterns.com/uploads/s4HAw97MRd5A2G73GMvnsb/logo_png_blanco.png" alt="Vivo Media — Tecnología visual en movimiento" className="h-full w-full object-contain object-left" data-id="element-86" data-mp="3v8rf7oxh4xv4" />
          </a>

          <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-87" data-mp="34gx5i4oqt84">
            {LINKS.map(link => <li key={link.href} data-id="element-88" data-mp="htd236bg3q4i">
                <a href={link.href} className="text-sm font-medium uppercase tracking-[0.08em] text-vm-muted transition-colors hover:text-white" data-id="element-89" data-mp="hsabz0ly5rpn">
                  {link.label}
                </a>
              </li>)}
          </ul>

          <div className="flex items-center gap-4" data-id="element-90" data-mp="mt7vphmlutt9">
            {SOCIALS.map(social => {
            const Icon = social.icon;
            return <a key={social.label} href={social.href} target={social.href === '#' ? undefined : '_blank'} rel={social.href === '#' ? undefined : 'noopener noreferrer'} aria-label={social.label} className="flex h-10 w-10 items-center justify-center border border-vm-muted/50 text-vm-muted transition-colors hover:border-vm-electric hover:text-white" data-id="element-91" data-mp="ytxyzp4ywl2j">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-92" data-mp="1hmifs87e6zpz" />
                </a>;
          })}
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 text-center lg:text-left" data-id="element-93" data-mp="1rj4vkikv30l5">
          <p className="text-sm font-light text-vm-muted" data-id="element-94" data-mp="3oboppmyxfvkq">
            © 2026 Vivo Media. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}